import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-ak-create-dialog',
    templateUrl: './ak-create-dialog.component.html',
    styleUrls: ['./ak-create-dialog.component.scss'],
    standalone: false
})
export class AkCreateDialogComponent implements OnInit {
  form: FormGroup;
  name: string;
  description: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AkCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.name, [Validators.required]],
      description: [this.description],
    });
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }
}
